/**
 * Browser glue for the app layer. The DOM is allowed here and is not allowed in the core or in the
 * derivation layer; this is the seam between them.
 */
import type { KeyValueStore } from '@core';

/** A resilient localStorage adapter (feature-detected; degrades to an in-memory map). */
export function browserKeyValueStore(): KeyValueStore {
  try {
    const ls = globalThis.localStorage;
    ls.getItem('ts.probe');
    return {
      get: (k) => ls.getItem(k),
      set: (k, v) => ls.setItem(k, v),
      remove: (k) => ls.removeItem(k),
    };
  } catch {
    const map = new Map<string, string>();
    return {
      get: (k) => map.get(k) ?? null,
      set: (k, v) => void map.set(k, v),
      remove: (k) => void map.delete(k),
    };
  }
}
